export default __webpack_public_path__ + "static/media/LSTM-POS.ceb583c7.png";